import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import {
  TechDocsLandingPage,
  TechDocsLandingPageIcon,
} from '@internal/backstage-plugin-landing-pages';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

/** Replaces the default TechDocs page with the internal landing page. */
const techdocsPageOverride = techdocsPlugin
  .getExtension('page:techdocs')
  .override({
    params: {
      title: 'TechDocs',
      icon: <TechDocsLandingPageIcon />,
      loader: async () => <TechDocsLandingPage />,
    },
  });

const techdocsReaderPageOverride = techdocsPlugin
  .getExtension('page:techdocs/reader')
  .override({
    params: {
      noHeader: true,
    },
  });

/** Bundles all TechDocs overrides into a single frontend module. */
export const techdocsPluginOverride = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techdocsPageOverride, techdocsReaderPageOverride],
});
